import { render, staticRenderFns } from "./Sitetype.vue?vue&type=template&id=12a0f728"
import script from "./Sitetype.vue?vue&type=script&lang=js"
export * from "./Sitetype.vue?vue&type=script&lang=js"
import style0 from "./Sitetype.vue?vue&type=style&index=0&id=12a0f728&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports